import * as z from "zod";

/**
 * Revoke a stored attestation by id. Trusted checkout-optimization users
 * only; scoped to the caller's account.
 */
export const revokeCheckoutAttestation = {
  name: "revokeCheckoutAttestation" as const,
  input: z.object({ attestationId: z.string() }),
  output: z.null(),
};
